import { Model } from "../base/Model";
export class BasketModel extends Model {
    constructor(data, events) {
        var _a;
        super(data, events);
        this.items = (_a = data === null || data === void 0 ? void 0 : data.items) !== null && _a !== void 0 ? _a : [];
    }
    addItem(item) {
        if (this.containsItem(item.id)) {
            return;
        }
        this.items.push(Object.assign({}, item));
        this.emitChanges('basket:items:updated', { items: this.getItems() });
    }
    removeItem(itemId) {
        const initialLength = this.items.length;
        this.items = this.items.filter(i => i.id !== itemId);
        if (this.items.length === initialLength) {
            return;
        }
        this.emitChanges('basket:items:updated', { items: this.getItems() });
    }
    getCount() {
        return this.items.length;
    }
    getItems() {
        return this.items.map(i => (Object.assign({}, i)));
    }
    getTotal() {
        return this.items.reduce((sum, it) => { var _a; return sum + ((_a = it.price) !== null && _a !== void 0 ? _a : 0); }, 0);
    }
    containsItem(itemId) {
        return this.items.some(i => i.id === itemId);
    }
    clearItems() {
        if (this.items.length === 0)
            return;
        this.items = [];
        this.emitChanges('basket:items:cleared', {});
        this.emitChanges('basket:items:updated', { items: this.getItems() });
    }
}
